module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"notice_bar":{"back_message":{"AT":"Zurück zur österreichischen Version.","CH":"Zurück zur schweizer Version.","DE":"Zurück zur deutschen Version."},"usage_message":{"AT":"Sie nutzen aktuell die österreichische Version der Website.","CH":"Sie nutzen aktuell die schweizer Version der Website.","DE":"Sie nutzen aktuell die deutsche Version der Website."}}}}}}')
  delete Component.options._Ctor
}
